export enum FeatureBundles {
  FamilyEngagementCore = "Family Engagement Core",
  LifestyleAndConcierge = "Lifestyle & Concierge",
  Maintenance = "Maintenance",
  DigitalSignage = "Digital Signage"
}